export const initialState = {
  Color: '#000000',
  TempColor: '#000000',
  Thickness: 2,
  Transparency: 1
}